var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getConfig)?_c(_vm.getConfig.startStop.level,{tag:"component",attrs:{"companyConfig":_vm.getConfig}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }